<template>
  <div class="content_all2" id="manage">
    <div class="content_box outer_box">
      <div class="n_box_l">
        <ul>
          <li :class="{ 'on': choose_type == '帳號資訊'}" @click="selectPage('帳號資訊')">帳號資訊</li>
          <li :class="{ 'on': choose_type == '變更聯絡人'}" @click="selectPage('變更聯絡人')">變更聯絡人</li>
          <li :class="{ 'on': choose_type == '帳號展延申請'}" @click="selectPage('帳號展延申請')">帳號展延申請</li>
          <li :class="{ 'on': choose_type == '變更密碼'}" @click="selectPage('變更密碼')">變更密碼</li>
        </ul>
        <ul>
          <li class="on" style="margin-top: 20px;font-size: 16px;text-align: center;font-weight: bold;">每年7/31前<br>須申請展延</li>
        </ul>
      </div>
      <div class="n_box_r">
        <div v-show="choose_type == '帳號資訊'">
          <div class="list_box w100pa">
            <div class="n_ta1">
              <table>
                <tr>
                  <th>年度</th>
                  <td>{{yearuser.rocYear}} 學年度</td>
                </tr>
                <tr>
                  <th>已展延年度</th>
                  <td>{{yearuser.lastRocYear}} 學年度</td>
                </tr>
                <tr>
                  <th>系所</th>
                  <td>{{yearuser.unitName}} {{showUnitType()}}</td>
                </tr>
                <tr>
                  <th>類別</th>
                  <td>{{showTeamType()}}</td>
                </tr>
              </table>
            </div>
            <div class="n_bar">負責人 / 聯絡人</div>
            <div class="n_ta1">
              <table>
                <tr>
                  <th>姓名</th>
                  <td>{{yearuser.contactName}}</td>
                </tr>
                <tr>
                  <th>學號</th>
                  <td>{{yearuser.contactSchoolId}}</td>
                </tr>
                <tr>
                  <th>電話</th>
                  <td>{{yearuser.contactMobile}}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{{yearuser.contactEmail}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div v-show="choose_type == '變更聯絡人'">
          <div class="list_box w100pa">
            <div class="n_ta2">
              <table>
                <tr>
                  <th><span class="note">*</span>姓名</th>
                  <th><span class="note">*</span>學號</th>
                </tr>
                <tr>
                  <td>
                    <input name="" type="text" class="input_style" v-model="recordToEdit.contactName">
                  </td>
                  <td>
                    <input name="" type="text" class="input_style" v-model="recordToEdit.contactSchoolId">
                  </td>
                </tr>
                <tr>
                  <th><span class="note">*</span>電話</th>
                  <th><span class="note">*</span>Email</th>
                </tr>
                <tr>
                  <td>
                    <input name="" type="text" class="input_style" v-model="recordToEdit.contactMobile">
                  </td>
                  <td>
                    <input name="" type="text" class="input_style" v-model="recordToEdit.contactEmail">
                  </td>
                </tr>
              </table>
            </div>
            <div class="psbox">注意事項</div>
            <div class="tomi mt15">
              <input name="" type="checkbox" value="" v-model="agree1"> 我已閱讀相關注意事項
            </div>
            <div class="tomi mt15">
              <button type="submit" class="btn_m" @click="saveData">送出修改</button>
            </div>
          </div>
        </div>
        <div v-show="choose_type == '帳號展延申請'">
          <div class="list_box w100pa">
            <div class="n_ta1">
              <table>
                <tr>
                  <th>原帳號年度</th>
                  <td>{{yearuser.rocYear}}學年度</td>
                </tr>
                <tr>
                  <th>申請展延年度</th>
                  <td>{{nowRocYear}} 學年度</td>
                </tr>
              </table>
            </div>
            <div class="psbox">注意事項</div>
            <div v-if="!nowExtendApply">
              <div class="tomi mt15">
                <input name="" type="checkbox" value="" v-model="agree2"> 我已閱讀相關注意事項
              </div>
              <div class="tomi mt15">
                <button type="submit" class="btn_m" @click="saveExtend">送出申請</button>
              </div>
            </div>
            <div v-else>
              審核狀態 {{showApplyStatus()}}
            </div>
          </div>
        </div>
        <div v-show="choose_type == '變更密碼'">
          <div class="list_box w100pa">
            <div class="mt5 mb5">
              帳號：　{{account}}
            </div>
            <div class="mt5 mb5">
              <input name="" type="text" class="input_style" placeholder="輸入舊密碼" v-model="oldPassword">
            </div>
            <div class="mt5 mb5">
              <input name="" type="text" class="input_style" placeholder="輸入新密碼" v-model="newPassword1">
            </div>
            <div class="mt5 mb5">
              <input name="" type="text" class="input_style" placeholder="再次輸入新密碼" v-model="newPassword2">
            </div>
            <div class="mt5 mb5">
              <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"></vue-recaptcha>
            </div>
            <div class="tomi mt15">
              <button type="submit" class="btn_m" @click="savePassword">送出</button>
              <!--<button type="submit" class="btn_m"　>送出</button>-->
            </div>
          </div>
        </div>
      </div>
      <div class="fix"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';
import VueRecaptcha from 'vue-recaptcha';


export default {
  name: 'manage',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      choose_type: "帳號資訊",
      yearuserId: sessionStorage.YearUserId,
      yearuser: '',
      firstApply: '',
      nowExtendApply: '',
      recordToEdit: '',
      agree1: false,
      agree2: false,
      account: sessionStorage.Account,
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      nowRocYear: '',
      verifycode: ''

    };
  },
  created() {
    axios.defaults.headers.common['X-Jesda-Api-Key'] = sessionStorage.getItem("TokenID");
    this.init();
  },

  methods: {
    onSubmit: function() {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function(response) {
      this.verifycode = response
      console.log(this.verifycode)
    },
    init() {
      this.initNowRocYear();
      this.getYearUser();
      this.getFirstApply();
      this.getNowExtendApply();
    },
    initNowRocYear() {
      let now = new Date();
      this.nowRocYear = now.getFullYear() - 1911;
    },

    getYearUser() {
      axios.get(API.rent_yearuser + `?id=${this.yearuserId}`)
        .then(response => {
          this.yearuser = response.data;
          this.recordToEdit = Object.assign({}, this.yearuser);
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getFirstApply() {
      axios.get(API.rent_yearuserapply + `?yearuserId=${this.yearuserId}&applyType=1`)
        .then(response => {
          this.firstApply = response.data.filter(data => {
            return data.trash !== 1;
          })[0];
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getNowExtendApply() {
      axios.get(API.rent_yearuserapply + `?yearuserId=${this.yearuserId}&applyType=2&rocYear=${this.nowRocYear}`)
        .then(response => {
          this.nowExtendApply = response.data.filter(data => {
            return data.trash !== 1;
          })[0];
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    saveData() {
      try {
        this.checkField();
      } catch (error) {
        alert(error.message);
        return;
      }
      let form = new FormData();

      form.append('id', this.yearuserId);

      form.append('contactName', this.recordToEdit.contactName);
      form.append('contactSchoolId', this.recordToEdit.contactSchoolId);
      form.append('contactMobile', this.recordToEdit.contactMobile);
      form.append('contactEmail', this.recordToEdit.contactEmail);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_yearuser, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_yearuser');
        });
    },
    checkField() {
      if (!this.agree1)
        throw new Error('請閱讀相關注意事項');
      if (!this.recordToEdit.contactName)
        throw new Error('請填寫聯絡人姓名');
      if (!this.recordToEdit.contactSchoolId)
        throw new Error('請填寫聯絡人學號');
      if (!this.recordToEdit.contactMobile)
        throw new Error('請填寫聯絡人電話');
      if (!this.recordToEdit.contactEmail)
        throw new Error('請填寫聯絡人Email');
      this.checkMobile();
      this.checkEmail();
    },
    verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    checkMobile() {
      let regExp = /^09[0-9]{8}$/;
      if (this.recordToEdit.contactMobile && !this.recordToEdit.contactMobile.match(regExp)) {
        throw new Error('電話欄位無效');
      }
    },
    checkEmail() {
      let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.recordToEdit.contactEmail && !this.recordToEdit.contactEmail.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    },

    savePassword() {
      try {
        this.checkOldPassword()
        this.checkNewPassword1()
        this.checkNewPassword2()
        this.verify()

      } catch (error) {
        alert(error.message);
        return;
      }

      let form = new FormData();

      form.append('oldPassword', this.oldPassword);
      form.append('newPassword', this.newPassword1);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_yearuser + '/newpassword', form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_yearuser');
        });
    },
    checkPasswordField() {
      if (this.newPassword1 !== this.newPassword2)
        throw new Error('新密碼不相同，請重新確認');
    },
    checkOldPassword() {
      if (!this.oldPassword) {
        throw new Error('請輸入舊密碼');
      }
    },
    checkNewPassword1() {
      if (!this.newPassword1) {
        throw new Error('請輸入新密碼');
      }
    },
    checkNewPassword2() {
      if (!this.newPassword2) {
        throw new Error('請再次輸入新密碼');
      }
      if (this.newPassword1 != this.newPassword2)
        throw new Error('兩次密碼不符');
    },
    saveExtend() {
      try {
        this.checkNowExtendApplyField();
      } catch (error) {
        alert(error.message);
        return;
      }
      let form = new FormData();

      form.append('yearUserId', this.yearuserId);
      form.append('rocYear', this.nowRocYear);
      form.append('status', '0');
      form.append('applyType', 2);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_yearuserapply, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.getNowExtendApply();
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_yearuserapply');
        });
    },
    checkNowExtendApplyField() {
      if (this.nowExtendApply)
        throw new Error('無法申請');
      if (!this.agree2)
        throw new Error('請閱讀相關注意事項');
      // if(!this.nowExtendApply.rocYear)
      //  throw new Error('請選擇學年度');
    },


    goBack() {
      // window.window.history.go(-1)
      window.history.go(-1)

    },
    selectPage(page) {
      this.choose_type = page
    },

    showUnitType() {
      let show = ['', '大學部', '研究所', '社團'];
      return show[this.yearuser.unitType];
    },
    showTeamType() {
      let show = ['', '男子籃球隊', '男子排球隊', '男子足球隊', '棒球隊', '女子籃球隊', '女子排球隊', '女子足球隊', '壘球隊', this.yearuser.teamTypeOther];
      return show[this.yearuser.teamType];
    },
    showApplyStatus() {
      let show = ['未處理', '通過', '未通過'];
      return show[this.nowExtendApply.status];
    },
  },
}

</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// Manage.vue?153d6d07